import * as yup from 'yup';
import { each } from 'lodash';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { isValidPhoneNumber } from 'react-phone-number-input';
import React, { useState, forwardRef, useImperativeHandle } from 'react';

import FormInput from 'partial/form/FormInput';
import { useActiveAccount } from 'modules/auth/hooks';
import Form, { ErrorLabel } from 'partial/form/Form';
import FormMobileNumber from 'partial/form/FormMobileNumber';

const validationSchema = yup.object().shape({
  representative_contact_number: yup
    .string()
    .required('Required')
    .test({
      name: 'must be valid',
      test: (value) => isValidPhoneNumber(value || ''),
      message: 'Invalid',
    }),
  name: yup.string().required('Required'),
});

const OrganizationForm = forwardRef(
  ({ readOnly, onSubmit, onSuccess }, ref) => {
    const [account] = useActiveAccount();

    const [validateOnChange, setValidateOnChange] = useState(false);

    const { values, setFieldValue, handleSubmit, errors } = useFormik({
      initialValues: account,
      validationSchema,

      onSubmit: async (form, { setFieldError }) => {
        onSubmit(form, onSuccess, (err) => {
          each(err?.response?.errors, (v, k) => {
            setFieldError(k, v);
          });
        });
      },
      validateOnChange,
    });

    useImperativeHandle(
      ref,
      () => ({
        submit: handleSubmit,
        setValidateOnChange,
      }),
      [handleSubmit, setValidateOnChange]
    );

    return (
      <Form onSubmit={handleSubmit} error={errors} noValidate>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <FormInput
              name="name"
              label="Organization Name"
              type="text"
              required
              onSetFieldValue={setFieldValue}
              value={values?.name}
              error={errors?.name}
            />
            <ErrorLabel name="name" />
          </div>
          <div>
            <div className="relative z-10">
              <FormMobileNumber
                name="representative_contact_number"
                label="Contact Mobile No"
                onSetFieldValue={setFieldValue}
                value={values?.representative_contact_number}
                error={errors?.representative_contact_number}
                readOnly={readOnly}
                required
              />
            </div>
            <ErrorLabel name="representative_contact_number" />
          </div>
        </div>
      </Form>
    );
  }
);

OrganizationForm.defaultProps = {
  readOnly: false,
};

OrganizationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

export default OrganizationForm;
